var map = {
	"./AdGuardDnsInfo.vue": [
		62488,
		[
			2488
		]
	],
	"./AdGuardFilterStatus.vue": [
		38416,
		[
			8416
		]
	],
	"./AdGuardStats.vue": [
		56256,
		[
			2657,
			6256
		]
	],
	"./AdGuardTopDomains.vue": [
		99718,
		[
			9718
		]
	],
	"./AnonAddy.vue": [
		9600,
		[
			9600
		]
	],
	"./Apod.vue": [
		28558,
		[
			8558
		]
	],
	"./BlacklistCheck.vue": [
		91497,
		[
			1497
		]
	],
	"./Blank.vue": [
		24387,
		[
			4387
		]
	],
	"./ChuckNorris.vue": [
		84543,
		[
			4543
		]
	],
	"./Clock.vue": [
		7783,
		[
			7783
		]
	],
	"./CodeStats.vue": [
		89880,
		[
			2657,
			9880
		]
	],
	"./CovidStats.vue": [
		559,
		[
			2657,
			559
		]
	],
	"./CryptoPriceChart.vue": [
		15058,
		[
			2657,
			5058
		]
	],
	"./CryptoWatchList.vue": [
		62014,
		[
			2014
		]
	],
	"./CustomList.vue": [
		98220,
		[
			8220
		]
	],
	"./CustomSearch.vue": [
		12118,
		[
			2118
		]
	],
	"./CveVulnerabilities.vue": [
		7300,
		[
			7300
		]
	],
	"./DomainMonitor.vue": [
		89954,
		[
			9954
		]
	],
	"./DroneCi.vue": [
		45364,
		[
			5364
		]
	],
	"./EmbedWidget.vue": [
		41138,
		[
			1138
		]
	],
	"./EthGasPrices.vue": [
		83319,
		[
			2657,
			3319
		]
	],
	"./ExchangeRates.vue": [
		26056,
		[
			6056
		]
	],
	"./Filebrowser.vue": [
		10335,
		[
			7809,
			335
		]
	],
	"./Flights.vue": [
		78152,
		[
			8152
		]
	],
	"./GitHubProfile.vue": [
		11758,
		[
			1758
		]
	],
	"./GitHubTrending.vue": [
		43941,
		[
			3941
		]
	],
	"./GlAlerts.vue": [
		15343,
		[
			5343
		]
	],
	"./GlCpuCores.vue": [
		75429,
		[
			5429
		]
	],
	"./GlCpuGauge.vue": [
		48294,
		[
			8294
		]
	],
	"./GlCpuHistory.vue": [
		4964,
		[
			2657,
			4964
		]
	],
	"./GlCpuSpeedometer.vue": [
		59212,
		[
			9212
		]
	],
	"./GlCpuTemp.vue": [
		75048,
		[
			5048
		]
	],
	"./GlDiskIo.vue": [
		11157,
		[
			1157
		]
	],
	"./GlDiskSpace.vue": [
		18840,
		[
			8840
		]
	],
	"./GlIpAddress.vue": [
		4456,
		[
			4456
		]
	],
	"./GlLoadHistory.vue": [
		85998,
		[
			2657,
			5998
		]
	],
	"./GlMemGauge.vue": [
		58726,
		[
			8726
		]
	],
	"./GlMemHistory.vue": [
		59402,
		[
			2657,
			9402
		]
	],
	"./GlMemSpeedometer.vue": [
		97406,
		[
			7406
		]
	],
	"./GlNetworkInterfaces.vue": [
		28986,
		[
			8986
		]
	],
	"./GlNetworkTraffic.vue": [
		6203,
		[
			2657,
			6203
		]
	],
	"./GlSystemLoad.vue": [
		1175,
		[
			2657,
			1175
		]
	],
	"./GluetunStatus.vue": [
		16737,
		[
			6737
		]
	],
	"./HackernewsTrending.vue": [
		5146,
		[
			5146
		]
	],
	"./HealthChecks.vue": [
		48149,
		[
			8149
		]
	],
	"./IframeWidget.vue": [
		67595,
		[
			7595
		]
	],
	"./ImageWidget.vue": [
		16479,
		[
			6479
		]
	],
	"./Jokes.vue": [
		34060,
		[
			4060
		]
	],
	"./Linkding.vue": [
		17524,
		[
			7524
		]
	],
	"./MinecraftStatus.vue": [
		44217,
		[
			4217
		]
	],
	"./MullvadStatus.vue": [
		3705,
		[
			3705
		]
	],
	"./Mvg.vue": [
		77640,
		[
			7640
		]
	],
	"./MvgConnection.vue": [
		92647,
		[
			2647
		]
	],
	"./NdCpuHistory.vue": [
		69091,
		[
			2657,
			9091
		]
	],
	"./NdLoadHistory.vue": [
		38415,
		[
			2657,
			8415
		]
	],
	"./NdRamHistory.vue": [
		5606,
		[
			2657,
			5606
		]
	],
	"./NewsHeadlines.vue": [
		90352,
		[
			352
		]
	],
	"./NextcloudNotifications.vue": [
		58227,
		[
			8227
		]
	],
	"./NextcloudPhpOpcache.vue": [
		6122,
		[
			3741
		]
	],
	"./NextcloudStats.vue": [
		86908,
		[
			6908
		]
	],
	"./NextcloudSystem.vue": [
		3299,
		[
			2657,
			3299
		]
	],
	"./NextcloudUser.vue": [
		83126,
		[
			3126
		]
	],
	"./NextcloudUserStatus.vue": [
		78798,
		[
			8798
		]
	],
	"./PiHoleStats.vue": [
		83752,
		[
			2657,
			3752
		]
	],
	"./PiHoleStatsV6.vue": [
		33114,
		[
			2657,
			3114
		]
	],
	"./PiHoleTopQueries.vue": [
		66609,
		[
			6609
		]
	],
	"./PiHoleTopQueriesV6.vue": [
		31683,
		[
			1683
		]
	],
	"./PiHoleTraffic.vue": [
		86210,
		[
			2657,
			6210
		]
	],
	"./PiHoleTrafficV6.vue": [
		69028,
		[
			2657,
			9028
		]
	],
	"./Proxmox.vue": [
		39827,
		[
			9827
		]
	],
	"./PublicHolidays.vue": [
		56938,
		[
			6938
		]
	],
	"./PublicIp.vue": [
		64227,
		[
			4227
		]
	],
	"./RescueTime.vue": [
		24551,
		[
			4551
		]
	],
	"./RssFeed.vue": [
		34013,
		[
			4013
		]
	],
	"./Sabnzbd.vue": [
		56828,
		[
			6828
		]
	],
	"./SportsScores.vue": [
		20743,
		[
			743
		]
	],
	"./StatPing.vue": [
		67644,
		[
			7644
		]
	],
	"./StockPriceChart.vue": [
		28341,
		[
			2657,
			8341
		]
	],
	"./SynologyDownload.vue": [
		52867,
		[
			2867
		]
	],
	"./SystemInfo.vue": [
		28806,
		[
			2657,
			8806
		]
	],
	"./TacticalRMM.vue": [
		11208,
		[
			1208
		]
	],
	"./TflStatus.vue": [
		80461,
		[
			461
		]
	],
	"./UptimeKuma.vue": [
		7526,
		[
			7809,
			7526
		]
	],
	"./UptimeKumaStatusPage.vue": [
		15256,
		[
			5256
		]
	],
	"./WalletBalance.vue": [
		47388,
		[
			7388
		]
	],
	"./Weather.vue": [
		4718,
		[
			4718
		]
	],
	"./WeatherForecast.vue": [
		54045,
		[
			4045
		]
	],
	"./WidgetBase.vue": [
		88714,
		[]
	],
	"./XkcdComic.vue": [
		39434,
		[
			9434
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 42625;
module.exports = webpackAsyncContext;